import { Popper, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { FC, useState, useEffect } from 'react';

import { ReactComponent as SelectArrowIcon } from '../../_assets/images/select-arrow.svg';
import { get } from '../../core/client';
import { useAppSelector } from '../../store';
import { IHobby, initialStateHobby } from '../../models/profile/hobbyAndInterest';

const HobbyAndInterest: FC<any> = (props) => {
    const [state, setState] = useState<IHobby>(initialStateHobby);
    const [hobbyDetailOptions, setHobbyDetailOptions] = useState({ items: [] });
    const { hobbyOptions } = useAppSelector(state => state.profile);
    const { words } = useAppSelector(state => state.localization);

    const getHobbyDetails = async (id: string) => {
        const response = await get<any>(`joy/get-joy-list-by-type-id?id=${id}`);
        if (response.isSuccessful && response.result) {
            setHobbyDetailOptions({
                items: response?.result?.items,
            });
        }
    };

    useEffect(() => {
        if (state !== props.data && state !== initialStateHobby) {
            props.updateInterestAndHobby(state, props.index);
        }
    }, [state]);

    useEffect(() => {
        setState(props.data);
    }, []);

    useEffect(() => {
        if (!state.joyTypeId) return;
        if (state?.joyTypeId) {
            getHobbyDetails(state.joyTypeId);
        }
    }, [state?.joyTypeId]);

    const CustomPopper = props => {
        return <Popper {...props} className="dropdown-01" placement="bottom" />;
    };

    const CustomPopper2 = props => {
        return <Popper {...props} className={!state.joyTypeId ? 'dropdown-01 d-none' : 'dropdown-01'} placement="bottom" />;
    };

    return (
        <>
            <div className={props.isTouched && !state.joyTypeId ? 'c-unit-01 form-group-04 error' : 'c-unit-01 form-group-04'}>
                <label className="label-01">{words && words['WEB.hobby']}</label>
                <Autocomplete
                    disabled={!props.isEdit}
                    noOptionsText={words && words['WEB.resultNotFounded']}
                    fullWidth={true}
                    PopperComponent={CustomPopper}
                    closeIcon=""
                    id={'interestsCategory-' + state?.joyTypeId}
                    value={{ joyTypeId: state?.joyTypeId, name: state?.joyTypeName }}
                    onChange={(e: any, val: any) => setState({ ...state, joyTypeId: val?.id, joyId: '', joyTypeName: val?.name })}
                    getOptionLabel={(option: any) => (option && option?.name ? option.name : '')}
                    options={hobbyOptions?.items ? hobbyOptions?.items : []}
                    className={props.isTouched && !state.joyTypeId ? 'autocomplete-05 error' : 'autocomplete-05'}
                    renderInput={params => (
                        <div ref={params.InputProps.ref} className="render-container">
                            <input
                                {...params.inputProps}
                                className="render-input"
                                placeholder={words && words['WEB.choose']}
                            />
                            {props.isEdit && <SelectArrowIcon className="red-arrow" />}
                        </div>
                    )}
                />

                {props.isTouched && !state.joyTypeId && <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>}
            </div>
            <>
                <div className={props.isTouched && !state.joyId ? 'c-unit-01 form-group-04 error' : 'c-unit-01 form-group-04'}>
                    <label className="label-01">{words && words['WEB.hobbyDetail']}</label>
                    <Autocomplete
                        disabled={!props.isEdit}
                        noOptionsText={words && words['WEB.resultNotFounded']}
                        fullWidth={true}
                        PopperComponent={CustomPopper2}
                        closeIcon=""
                        id={'interestsName-' + state?.joyId}
                        value={{ id: state?.joyId, name: state?.joyName }}
                        onChange={(e: any, val: any) => {
                            setState({ ...state, joyId: val?.id, isOther: val?.isOther, joyName: val?.name, isOtherDetail: '' });
                        }}
                        getOptionLabel={(option: any) => (option && option?.name ? option?.name : '')}
                        options={hobbyDetailOptions?.items ? hobbyDetailOptions?.items : []}
                        className={props.isTouched && (!state.joyId || state.joyId === undefined) ? 'autocomplete-05 error' : 'autocomplete-05'}
                        renderInput={params => (
                            <div ref={params.InputProps.ref} className="render-container">
                                <input
                                    {...params.inputProps}
                                    className="render-input"
                                    placeholder={words && words['WEB.choose']}
                                />
                                {props.isEdit && <SelectArrowIcon className="red-arrow" />}
                            </div>
                        )}
                    />

                    {props.isTouched && !state.joyId && <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>}
                </div>
            </>
            {state?.isOther && (
                <div className={props.isTouched && !state.isOtherDetail ? 'c-unit-01 form-group-04 error' : 'c-unit-01 form-group-04'}>
                    <label className="label-01">{words && words['WEB.OTHER']}</label>
                    <TextField
                        disabled={!props.isEdit}
                        placeholder={words && words['WEB.noInformationShared']}
                        className={props.isTouched && !state.isOtherDetail ? 'textfield-02 error' : 'textfield-02'}
                        id="hobby-texfield"
                        value={state?.isOtherDetail}
                        onChange={(e: any) => setState({ ...state, isOtherDetail: e?.target?.value })}
                    />

                    {props.isTouched && !state.isOtherDetail && (
                        <span className="validation-error-message-01">*{words && words['WEB.requiredField']}</span>
                    )}
                </div>
            )}

            {props.isEdit && (
                <a className="c-unit-02" onClick={() => props.deleteInterestAndHobbyByIndex(props.index)}>
                    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1.29032 16.3125C1.29032 16.7601 1.47093 17.1893 1.79242 17.5057C2.11391 17.8222 2.54995 18 3.0046 18H13.2903C13.745 18 14.181 17.8222 14.5025 17.5057C14.824 17.1893 15.0046 16.7601 15.0046 16.3125V4.5H1.29032V16.3125ZM11.0046 7.3125C11.0046 7.16332 11.0648 7.02025 11.172 6.91476C11.2791 6.80927 11.4245 6.75 11.576 6.75C11.7276 6.75 11.8729 6.80927 11.9801 6.91476C12.0873 7.02025 12.1475 7.16332 12.1475 7.3125V15.1875C12.1475 15.3367 12.0873 15.4798 11.9801 15.5852C11.8729 15.6907 11.7276 15.75 11.576 15.75C11.4245 15.75 11.2791 15.6907 11.172 15.5852C11.0648 15.4798 11.0046 15.3367 11.0046 15.1875V7.3125ZM7.57603 7.3125C7.57603 7.16332 7.63624 7.02025 7.7434 6.91476C7.85056 6.80927 7.99591 6.75 8.14746 6.75C8.29901 6.75 8.44436 6.80927 8.55152 6.91476C8.65869 7.02025 8.71889 7.16332 8.71889 7.3125V15.1875C8.71889 15.3367 8.65869 15.4798 8.55152 15.5852C8.44436 15.6907 8.29901 15.75 8.14746 15.75C7.99591 15.75 7.85056 15.6907 7.7434 15.5852C7.63624 15.4798 7.57603 15.3367 7.57603 15.1875V7.3125ZM4.14746 7.3125C4.14746 7.16332 4.20766 7.02025 4.31483 6.91476C4.42199 6.80927 4.56734 6.75 4.71889 6.75C4.87044 6.75 5.01579 6.80927 5.12295 6.91476C5.23011 7.02025 5.29032 7.16332 5.29032 7.3125V15.1875C5.29032 15.3367 5.23011 15.4798 5.12295 15.5852C5.01579 15.6907 4.87044 15.75 4.71889 15.75C4.56734 15.75 4.42199 15.6907 4.31483 15.5852C4.20766 15.4798 4.14746 15.3367 4.14746 15.1875V7.3125ZM15.576 1.12501H11.2903L10.9546 0.467584C10.8835 0.327034 10.7739 0.208807 10.6383 0.126202C10.5026 0.0435979 10.3463 -0.000106452 10.1867 6.16384e-06H6.1046C5.94545 -0.000596081 5.78935 0.0429453 5.65418 0.125642C5.519 0.208338 5.41023 0.326845 5.34032 0.467584L5.0046 1.12501H0.71889C0.567337 1.12501 0.421992 1.18427 0.314829 1.28976C0.207665 1.39525 0.147461 1.53832 0.147461 1.68751L0.147461 2.81251C0.147461 2.96169 0.207665 3.10476 0.314829 3.21025C0.421992 3.31574 0.567337 3.37501 0.71889 3.37501H15.576C15.7276 3.37501 15.8729 3.31574 15.9801 3.21025C16.0873 3.10476 16.1475 2.96169 16.1475 2.81251V1.68751C16.1475 1.53832 16.0873 1.39525 15.9801 1.28976C15.8729 1.18427 15.7276 1.12501 15.576 1.12501Z"
                            fill="#BCB8B8"
                        />
                    </svg>
                </a>
            )}
        </>
    );
};
export default HobbyAndInterest;
